"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var palette_1 = require("../constants/palette");

var scales_1 = require("../constants/scales"); // TODO: What are we going to do about padding?!


var ListGroupItem = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: block;\n  padding: ", ";\n  background-color: ", ";\n  color: ", ";\n  border-bottom: 1px solid rgb(233, 233, 233);\n\n  &:last-of-type {\n    border-bottom: 0;\n  }\n}\n"], ["\n  position: relative;\n  display: block;\n  padding: ", ";\n  background-color: ", ";\n  color: ", ";\n  border-bottom: 1px solid rgb(233, 233, 233);\n\n  &:last-of-type {\n    border-bottom: 0;\n  }\n}\n"])), function (props) {
  if (props.compact) return scales_1.responsive['8'] + "rem " + scales_1.responsive['16'] + "rem";
  return scales_1.responsive['16'] + "rem " + scales_1.responsive['16'] + "rem";
}, function (props) {
  if (props.header) return palette_1.default.tableHeaders;
  if (props.disabled) return palette_1.default.lighterGrey;
  return '';
}, function (props) {
  return props.header ? palette_1.default.darkGrey : '';
});
exports.default = ListGroupItem;
var templateObject_1;